module.exports = __webpack_public_path__ + "static/assets/9d34e28dd3ee4bc95470219ab2173b1f.png";